import {
  Button,
  Col,
  Divider,
  Input,
  Popconfirm,
  Row,
} from "antd";
import {
  PlusCircleOutlined,
} from "@ant-design/icons";

import FormLayout from "../../FormLayout/FormLayout";
import NameField from "../../Fields/NameField/NameField";
import LastNameField from "../../Fields/LastNameField/LastNameField";
import SecondLastNameField from "../../Fields/SecondLastNameField/SecondLastNameField";
import EmailField from "../../Fields/EmailField/EmailField";
import TextField from "../../Fields/TextField/TextField";

import { useContacts } from "../../../Hooks/useContacts/useContacts";

import { InvestorAPI } from "../../../Api/InvestorAPI";
import { ContactsAPI } from "../../../Api/ContactsAPI";
import { DistributorsAPI } from "../../../Api/DistributorsAPI";
import { ContractAPI } from "../../../Api/ContractAPI";

import { IContacts } from "./IContacts";
import { Contact } from "../../../Models";

import "./Contacts.scss";
import { InvestorDTO } from "../../../Models/InvestorDTO";

const Contacts = ({
	baseURL,
	baseURLExternal,
	translations,
	clientId,
	unlockNextStep,
	isReadOnly = false,
}: IContacts) => {
	const investorAPI = InvestorAPI(baseURL, baseURLExternal, clientId);
	const contactAPI = ContactsAPI(baseURL, clientId);
	const distributorsAPI = DistributorsAPI(baseURL, clientId);
	const contractAPI = ContractAPI(baseURL, baseURLExternal, clientId);

	const {
		loading,
		errors,
		contacts,
		contractId,
		addRow,
		handleChangeData,
		deleteRow,
		saveData,
		oldContacts  
	} = useContacts({
		translations,
		investorAPI,
		contactAPI,
		distributorsAPI,
		unlockNextStep,
		contractAPI,
	});

  	return (
    	<FormLayout
			translations={translations}
			loading={loading}
			title={translations.contactosInversor}
			onClick={saveData}
			contractId={contractId}
			nextStep={unlockNextStep}
			enableNextStep={true}
			forceEnableNextStep={isReadOnly}
			hideSaveButton={isReadOnly}
		>
			<Button type="default" className="save-btn" onClick={addRow} disabled={isReadOnly}>
				<PlusCircleOutlined />
				{translations.masContacto}
			</Button>
      		{oldContacts.map((oldContact: InvestorDTO, i: number) => (
				<Row gutter={[16, 16]} align="bottom" key={i}>
					<Col xs={24} md={12} lg={12} >
						<label> {translations.nombreFirmante}</label>
						<Input
							value={oldContact.name}
							disabled
						/>
					</Col>
					<Col xs={24} md={12} lg={12} >
						<label> {translations.firstLastnameSignatory}</label>
						<Input
							value={oldContact.lastName}
							disabled
						/>
					</Col>
					<Col xs={24} md={12} lg={12} >
						<label> {translations.secondLastnameSignatory}</label>
						<Input
							value={oldContact.secondLastName}
							disabled
						/>
					</Col>
					<Col xs={24} md={12} lg={6} >
						<label> {translations.type}</label>
						<Input
							value={translations[oldContact.type]}
							disabled
						/>
					</Col>
					<Col xs={24} md={12} lg={6} >
						<label> {translations.email}</label>
						<Input
							value={oldContact.emailContact ?? oldContact.email}
							disabled
						/>
					</Col>
					<Col xs={24} md={12} lg={6} >
						<label> {translations.phonePrefix}</label>
						<Input
							value={oldContact.phonePrefix}
							disabled
						/>
					</Col>
					<Col xs={24} md={12} lg={6} >
						<label> {translations.phoneNumber}</label>
						<Input
							value={oldContact.phoneNumber}
							disabled
						/>
					</Col>
					<Divider />
				</Row>
      		))}
      		{contacts.map((contact: Contact, i: number) => (
				<Row gutter={[16, 16]}>
					<NameField
						name={ contact.name }
						translations={ translations}
						errors={ errors }
						index={ i }
						handleChangeData={ handleChangeData }
						disabled={ isReadOnly }
					/>
					<LastNameField
						lastName={ contact.lastName }
						translations={ translations }
						errors={ errors }
						index={ i }
						handleChangeData={ handleChangeData }
						disabled={ isReadOnly }
					/>
					<SecondLastNameField
						lastName={ contact.secondLastName! }
						translations={ translations }
						errors={ errors }
						index={ i }
						handleChangeData={ handleChangeData }
						disabled={ isReadOnly }
					/>
					<EmailField
						value={ contact.email }
						fieldName="email"
						translations={ translations }
						errors={ errors }
						index={ i }
						handleChangeData={ handleChangeData }
						disabled={ isReadOnly }
					/>
					<TextField
						size='s'
						value={ contact.phonePrefix }
						fieldName="phonePrefix"
						placeholder="+34"
						translations={ translations }
						required
						errors={ errors }
						index={ i }
						handleChange={ handleChangeData }
						disabled={ isReadOnly }
					/>
					<TextField
						size='s'
						value={ contact.phoneNumber }
						fieldName="phoneNumber"
						placeholder="000 000 000"
						translations={ translations }
						required
						errors={ errors }
						index={ i }
						handleChange={ handleChangeData }
						disabled={ isReadOnly }
					/>
					<Col xs={24} md={3} lg={3} >
						<Popconfirm
							title={translations.eliminarContacto}
							okText={translations.si}
							placement="left"
							cancelText={translations.no}
							onConfirm={() => deleteRow(i)}
							disabled={isReadOnly}
						>
							<Button danger style={{marginTop: '22px'}} disabled={isReadOnly}>{translations.delete}</Button>
						</Popconfirm>
					</Col>
					<Divider />
				</Row>
			))}
    	</FormLayout>
  	);
};

export default Contacts;
